import { Panel } from "@itandi/itandi-bb-ui/Panel";
import { PanelBody } from "@itandi/itandi-bb-ui/PanelBody";
import { PanelHeader } from "@itandi/itandi-bb-ui/PanelHeader";
import { DefaultV2 } from "~/components/common/layouts/DefaultV2";
import { ClientSettingLayout } from "~/components/common/layouts/settings/ClientSettingLayout";
import { CompanyStoreSettingForm } from "~/components/specifics/settings/admin/company_store_settings/CompanyStoreSettingForm";
import type { ItandiAccount } from "~/models/ItandiAccount";

type Props = {
	currentStore: Exclude<ItandiAccount["store"], null>;
};

export function Page({ currentStore }: Props) {
	return (
		<DefaultV2>
			<ClientSettingLayout>
				<Panel>
					<PanelHeader title="店舗設定" />
					<PanelBody>
						<CompanyStoreSettingForm companyStoreSetting={currentStore} />
					</PanelBody>
				</Panel>
			</ClientSettingLayout>
		</DefaultV2>
	);
}
